import { IThunkActionCreator } from '../../types/store';
import { IFeedbackRequest, IFeedbackResponse } from '../../types/feedback';
import { sendFeedback } from '../../api/send_feedback';

export interface IFeedbackPopupOpened {
  type: 'FeedbackPopupOpened';
  opened: boolean;
}

export function sendFeedbackAction(parameters: IFeedbackRequest): IThunkActionCreator<Promise<IFeedbackResponse>> {
  return async (dispatch, getState, context) => {
    return sendFeedback(context.httpApi, parameters, context.subdomain);
  };
}

export const showFeedbackPopup = (opened = true): IFeedbackPopupOpened => ({
  opened,
  type: 'FeedbackPopupOpened',
});

export type Action = IFeedbackPopupOpened;
